import React ,{ Component }from "react";
import {
    FiCast,
    FiLayers,
    FiMonitor,
    FiAirplay,
    FiActivity,
    FiCoffee,
    FiCode,
    FiGrid,
    FiShield
} from "react-icons/fi";

const ServiceList = [
    {
        icon: <FiActivity />,
        title: 'AI-assisted Product Engineering',
        description: 'Codex, Claude, OpenAI and n8n workflows used pragmatically for scaffolding, refactoring, documentation, QA, and internal tools.'
    },
    {
        icon: <FiLayers />,
        title: 'React / Next.js Applications',
        description: 'Modern TypeScript web apps with clean UI, server-side flows, APIs, Prisma, PostgreSQL, Vercel deployment, and maintainable service layers.'
    },
    {
        icon: <FiGrid />,
        title: 'Design Patterns & Architecture',
        description: 'Reusable component systems, clean state boundaries, service patterns, API contracts, and pragmatic architecture choices that keep products easy to evolve.'
    },
    {
        icon: <FiMonitor />,
        title: 'Dashboards & Data Visualization',
        description: 'Operational interfaces, D3.js maps, benchmark views, filters, scoring systems, PDF export, and workflows built for repeated daily use.'
    },
    {
        icon: <FiAirplay />,
        title: '3D Web Experiences',
        description: 'Three.js and React Three Fiber scenes for product demos, art-tech visualization, interactive explainers, and game-inspired interfaces.'
    },
    {
        icon: <FiCode />,
        title: 'Web3 Development',
        description: 'Solidity, Ethers.js, Ethereum UI experiments, wallet-aware interfaces, and technical prototypes that connect blockchain concepts with polished web UX.'
    },
    {
        icon: <FiCast />,
        title: 'Mobile & Prototype Delivery',
        description: 'React Native and Expo prototypes, mobile UX, proof-of-concepts, MVP delivery, and fast iteration from kickoff to usable product.'
    },
    {
        icon: <FiCoffee />,
        title: 'Technical Strategy & Delivery',
        description: 'Project scoping, architecture choices, client-facing communication, Scrum delivery, production handoff, and pragmatic product decisions.'
    },
    {
        icon: <FiShield />,
        title: 'Testing, QA & Security',
        description: 'Focused test coverage, browser verification, accessibility checks, regression review, auth-aware flows, data validation, and secure implementation habits.'
    }
]


class ServiceThree extends Component{
    render(){
        const {column } = this.props;
        const ServiceContent = ServiceList.slice(0 , this.props.item);

        return(
            <React.Fragment>
                <div className="row">
                    {ServiceContent.map( (val , i) => (
                        <div className={`${column}`} key={i}>
                            <a href="#contact" aria-label={`Discuss ${val.title}`}>
                                <div
                                    className="service service__style--2 service-card-modern"
                                    style={{ '--service-index': i + 1 }}
                                >
                                    <span className="service-count">{`0${i + 1}`}</span>
                                    <div className="icon">
                                        {val.icon}
                                    </div>
                                    <div className="content">
                                        <h3 className="title">{val.title}</h3>
                                        <p>{val.description}</p>
                                    </div>
                                </div>
                            </a>
                        </div>
                    ))}
                </div>
            </React.Fragment>
        )
    }
}
export default ServiceThree;
